import { render, staticRenderFns } from "./empleadores.vue?vue&type=template&id=5ef5004d"
import script from "./empleadores.vue?vue&type=script&lang=js"
export * from "./empleadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports